import type { Locale } from "../Locale.js";
import { categoryPathMap } from "./categoryPathMap.js";

export function getWarehouseProductCategoryPath(locale: Locale, categoryName: keyof typeof categoryPathMap): string {
	// TODO if you need to change URL, you have to manually change it in footer as well. But dont do it.
	return `${categoryPathMap[categoryName][locale]}-express`;
}
